<div
  class="document-upload-container"
  [class.has-error]="(touched && required && value.length === 0) || (formControl?.invalid && formControl?.touched)"
>
  <label *ngIf="label" [for]="id || name" class="upload-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <!-- Upload Area -->
  <div
    *ngIf="value && value.length === 0"
    class="upload-area"
    [class.drag-over]="isDragOver"
    [class.disabled]="disabled"
    [class]="'upload-area ' + class"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (blur)="onBlur()"
  >
    <input
      [id]="id || name"
      [name]="name"
      type="file"
      [accept]="accept"
      [multiple]="multiple"
      [disabled]="disabled"
      (change)="onFileSelected($event)"
      class="file-input"
    />

    <div class="upload-content">
      <i class="upload-icon">{{ icon }}</i>
      <p class="upload-text">{{ placeholder }}</p>
      <p class="upload-hint">
        Maximum file size: {{ formatFileSize(maxFileSize) }}
        <span *ngIf="multiple"> | Max files: {{ maxFiles }}</span>
      </p>
      <!-- <button type="button" class="upload-button" [disabled]="disabled" (click)="document.getElementById(id || name)?.click()">
        Choose Files
      </button> -->
    </div>
  </div>

  <!-- Debug Info -->
  <!-- <div style="background: #f0f0f0; padding: 10px; margin: 10px 0; font-size: 12px">
    Debug: value.length = {{ value?.length }}, value = {{ value | json }}
  </div> -->

  <!-- File List -->
  <div *ngIf="value && value.length > 0" class="file-list">
    <div *ngFor="let file of value; trackBy: trackByFileId" class="file-item">
      <div class="file-info">
        <i class="file-icon" [class]="getFileIcon(file.type)"></i>
        <div class="file-details">
          <span class="file-name">{{ file.name }}</span>
          <!-- <span class="file-size">{{ formatFileSize(file.size) }}</span> -->

          <!-- Upload Progress -->
          <div *ngIf="file.isUploading" class="upload-progress">
            <div class="progress-container">
              <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="file.uploadProgress || 0"></div>
              </div>
              <span class="progress-text">{{ (file.uploadProgress && (file.uploadProgress | number : 2)) || 0 }}%</span>
            </div>
            <div class="progress-status">
              <span *ngIf="file.uploadProgress < 100" class="status-text">Uploading...</span>
              <span *ngIf="file.uploadProgress === 100" class="status-text success">Upload Complete!</span>
            </div>
          </div>

          <!-- Upload Error -->
          <div *ngIf="file.uploadError" class="upload-error">
            <i class="error-icon">error</i>
            <span class="error-text">{{ file.uploadError }}</span>
          </div>
        </div>
      </div>

      <div class="file-actions">
        <!-- Preview Button -->
        <span
          *ngIf="file.url && !file.isUploading && !file.uploadError"
          class="preview-button"
          [disabled]="disabled"
          (click)="previewFile(file)"
          title="Preview file (Dialog)"
        >
          <i class="preview-icon">Preview</i>
        </span>

        <!-- Route Preview Button -->

        <!-- Remove Button -->
        <span class="remove-button" [disabled]="disabled || file.isUploading" (click)="removeFile(file)" title="Remove file">
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
  </div>
  <!-- Error Message -->
  <div *ngIf="(touched && required && value.length === 0) || (formControl?.invalid && formControl?.touched)" class="error-message">
    <div *ngIf="touched && required && value.length === 0">Please upload at least one file.</div>
    <div *ngIf="formControl?.errors?.required && formControl?.touched">This field is required.</div>
    <div *ngIf="errors?.allowedTypes">Please upload a file of type {{ allowedTypes.join(', ') }}.</div>
    <div *ngIf="errors?.maxFileSize">Please upload a file smaller than {{ formatFileSize(maxFileSize) }}.</div>
    <div *ngIf="errors?.maxFiles">Please upload less than {{ maxFiles }} files.</div>
    <div *ngIf="errors?.onlyOneFileAllowed">Please upload only one file.</div>
    <div *ngIf="errors?.maximumFilesAllowed">Please upload less than {{ maxFiles }} files.</div>
    <div *ngIf="errors?.fileSizeTooLarge">Please upload a file smaller than {{ formatFileSize(maxFileSize) }}.</div>
    <div *ngIf="errors?.fileTypeNotAllowed">Please upload a file of type {{ allowedTypes }}.</div>
  </div>
</div>
